import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line-up",
  "use": "icon-line-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-line-up\">\n<g id=\"icon-line-up_Direction/line-up\">\n<g id=\"icon-line-up_icon/jiantou\">\n<path id=\"icon-line-up_chevron-down\" d=\"M12.4593 9.54165L11.54 10.4609L7.99966 6.92051L4.45928 10.4609L3.54004 9.54165L7.99966 5.08203L12.4593 9.54165Z\" fill=\"#282C33\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/line-up.svg
// module id = LnSP
// module chunks = 140